//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import traderTableConfig from './traderTableConfig';
import merchantTableConfig from './merchantTableConfig';
import ActionModal from './actionModal.vue';

export default {
  components: {
    ActionModal,
  },

  props: {
    value: { type: Boolean, default: false },
    showMerchantFees: { type: Boolean, default: false },
    showTraderFees: { type: Boolean, default: false },
    data: { type: [Array, Object], default: () => ([]) },
    iterators: { type: Array, default: () => ([]) },
    currencies: { type: Array, default: () => ([]) },
    paymentMethods: { type: Array, default: () => ([]) },
  },

  data() {
    return {
      settings: [],
      input: {},
      tableConfig: this.showMerchantFees ? merchantTableConfig : traderTableConfig,
      tab: 0,
      editing: {
        show: false,
        data: {},
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('tradersFees', {
      isSourcePaymentMethods: 'usePaymentMethodSettingsAsCommissionSource',
    }),
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    getTooltipText() {
      return this.isSourcePaymentMethods
        ? 'The user cannot make transactions with disabled payment methods'
        : 'The user cannot make transactions with disabled currencies';
    },

    isDataExist() {
      const { settings } = this.$props.data;
      if (Array.isArray(settings)) {
        return settings.length > 0;
      }

      if (typeof settings === 'object') {
        return Object.keys(settings).length > 0;
      }
      return false;
    },

    iteratorsList() {
      if (this.iterators.length > 0) return this.iterators;
      if (this.isSourcePaymentMethods) return this.paymentMethods;
      return this.currencies;
    },

    availableIds() {
      const sourceKey = this.isSourcePaymentMethods ? 'paymentMethods' : 'currencies';
      const source = this.$props.data?.[sourceKey];
      return Array.isArray(source) ? source : [];
    },

    filteredCurrencies() {
      if (this.isSourcePaymentMethods) {
        return this.iteratorsList.filter((paymentMethod) => this.availableIds.includes(paymentMethod.id));
      }
      return this.iteratorsList.filter((currency) => this.availableIds.includes(currency.id));
    },

    filteredSettings() {
      const ids = this.$props.data.settings.map((elem) => elem.currencyId || elem.paymentMethodId);
      const editableCurrencies = this.filteredCurrencies.filter((elem) => !ids.includes(elem.id));

      return editableCurrencies.concat(this.iteratorsList.filter((currency) => ids.includes(currency.id))).reverse();
    },

    currencyId() {
      return this.input.currencyId ?? 0;
    },

    tableRows() {
      const settings = Array.isArray(this.settings) ? this.settings : [];
      return this.availableIds.map((id) => {
        const setting = settings.find((item) => item.currencyId === id || item.paymentMethodId === id) || {};
        return {
          currencyId: id,
          currencyName: this.getIteratorName(id),
          isEnabled: setting.isEnabled ?? true,
          merchantPayoutRanges: this.formatRangeItems(setting.sellFeePercent),
          merchantPayinRanges: this.formatRangeItems(setting.buyFeePercent),
          merchantPayoutProfits: this.formatProfitItems(setting.sellFeePercent),
          merchantPayinProfits: this.formatProfitItems(setting.buyFeePercent),
          traderPayoutRanges: this.formatRangeItems(setting.sellProfitPercent),
          traderPayinRanges: this.formatRangeItems(setting.buyProfitPercent),
          traderPayoutProfits: this.formatProfitItems(setting.sellProfitPercent),
          traderPayinProfits: this.formatProfitItems(setting.buyProfitPercent),
        };
      });
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.input = {};
        this.settings = Array.isArray(this.$props.data?.settings) ? [...this.$props.data.settings] : [];
      }
    },
  },

  methods: {
    getIteratorName(id) {
      const item = this.iteratorsList.find((elem) => elem.id === id);
      if (!item) return String(id);
      return item.name || item.title || item.caption || String(id);
    },

    formatRangeItems(ranges) {
      if (!Array.isArray(ranges) || ranges.length === 0) return [];
      return ranges.map((range, index) => {
        const from = range?.amountFrom ?? '-';
        const to = range?.amountTo ?? '-';
        return `${index + 1}) ${from} - ${to}`;
      });
    },

    formatProfitItems(ranges) {
      if (!Array.isArray(ranges) || ranges.length === 0) return [];
      return ranges.map((range, index) => {
        const profit = (range?.profit ?? '-') === '-' ? '-' : `${range.profit}%`;
        return `${index + 1}) ${profit}`;
      });
    },

    openEditRow(row) {
      const parameterName = this.isSourcePaymentMethods ? 'paymentMethodId' : 'currencyId';
      const settings = Array.isArray(this.settings) ? this.settings : [];
      const existing = settings.find((item) => item[parameterName] === row.currencyId) || {};

      this.editing.data = {
        ...existing,
        currencyName: row.currencyName,
        [parameterName]: row.currencyId,
        isEnabled: existing.isEnabled ?? row.isEnabled ?? true,
        sellFeePercent: existing.sellFeePercent || [],
        sellProfitPercent: existing.sellProfitPercent || [],
        buyFeePercent: existing.buyFeePercent || [],
        buyProfitPercent: existing.buyProfitPercent || [],
      };
      this.editing.show = true;
    },

    handleEditSave(payload) {
      const parameterName = this.isSourcePaymentMethods ? 'paymentMethodId' : 'currencyId';
      const index = this.settings.findIndex((item) => item[parameterName] === payload[parameterName]);
      if (index >= 0) {
        const next = [...this.settings];
        next.splice(index, 1, payload);
        this.settings = next;
      } else {
        this.settings = [...this.settings, payload];
      }
    },

    apply() {
      const { settings } = this;
      this.$emit('apply', { settings });
    },

    saveFees(data, iteratorId) {
      const parameterName = this.isSourcePaymentMethods ? 'paymentMethodId' : 'currencyId';
      const index = this.settings.findIndex((elem) => elem.currencyId === iteratorId || elem.paymentMethodId === iteratorId);
      if (index >= 0) {
        this.settings[index] = { ...data, [parameterName]: iteratorId };
        if (!this.isSourcePaymentMethods) this.settings[index].userId = this.$route.params.id;
      } else {
        this.settings = [...this.settings, { ...data, [parameterName]: iteratorId }];
        if (!this.isSourcePaymentMethods) this.settings[index].userId = this.$route.params.id;
      }
    },

    getFeePercent(type, item) {
      const foundElem = this.$props.data.settings.find((elem) => elem.currencyId === item || elem.paymentMethodId === item);
      return foundElem ? foundElem[`${type}FeePercent`] : 0;
    },

    getProfitPercent(type, item) {
      const foundElem = this.$props.data.settings.find((elem) => elem.currencyId === item || elem.paymentMethodId === item);
      return foundElem ? foundElem[`${type}ProfitPercent`] : 0;
    },

    getEnabledStatus(item) {
      const foundElem = this.$props.data.settings.find((elem) => elem.currencyId === item || elem.paymentMethodId === item);
      return foundElem ? foundElem.isEnabled : true;
    },

    close() {
      this.$emit('close');
    },
  },
};
